/**
 * @changelog
 *
 * 2026-03-17 (0.1.0) (jhoward)
 *   - Add new src\helpers\getHotelOfferValidation.ts to validate hotel offer and return redirect URL.
 */

import type { FetchResponse } from '@framework/defs/framework';
import type { OpcOffer } from '@/defs/api/OpcOffer';
import peppermillCustomFetchProxy from '@/helpers/peppermillCustomFetchProxy';
import { validateBooking } from '@rss/actions/App/Http/Controllers/OfferController';

interface ValidateBookingResponse extends FetchResponse {
  data?: {
    redirect_url: string;
  };
}

export default async function getHotelOfferValidation(offer: OpcOffer): Promise<string | null> {
  if (offer.RESNET_OFFER_CODE.length) {
    const response = await peppermillCustomFetchProxy<ValidateBookingResponse>(
      {},
      {
        route: validateBooking({ offerCode: offer.CASINO_OFFER_CODE, offerDomain: offer.CASINO_OFFER_DOMAIN }),
        showLoadingSpinner: false,
      },
    );
    if (200 === response.status && response.data?.redirect_url) {
      return response.data.redirect_url;
    }
  }

  return null;
}
